import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  selectLeaguesSeasons,
  mapToDropdown,
} from '../../reducers/leagues_filter_values'
import {
  setConfigsSeason,
  selectConfigsSeason,
  SELECT_SEASON_PLACEHOLDER_VALUE,
} from '../../reducers/leagues_configs'

import { GlgSelect } from 'SharedComponents'

const LeaguesConfigDropdowns = () => {
  const dispatch = useDispatch()

  const seasons = useSelector(selectLeaguesSeasons)
  const configsSeason = useSelector(selectConfigsSeason)

  const placeholderItem = {
    value: SELECT_SEASON_PLACEHOLDER_VALUE,
    label: window.I18n.t('clone_leagues_sessions.dropdowns.select_a_season'),
  }
  const dropdownSeasons = [ placeholderItem, ...mapToDropdown(seasons) ]

  const handleSeasonChange = (seasonID) => {
    if (seasonID === SELECT_SEASON_PLACEHOLDER_VALUE) {
      dispatch(setConfigsSeason({}))
    } else {
      dispatch(setConfigsSeason({ value: seasonID, label: seasons[seasonID] }))
    }
  }

  return (
    <div className={'cls-lcd-sc-container'}>
      <div className={'dropdowns-grid'}>
        {/* Season */}
        <div className={'dropdown-wrapper'}>
          <span className={'dropdown-label'}>
            {window.I18n.t('clone_leagues_sessions.general.season')}
          </span>
          <span>
            <GlgSelect
              onChange={handleSeasonChange}
              value={configsSeason?.value}
              selectorClassName={'dropdown-select'}
              items={dropdownSeasons}
            />
          </span>
        </div>
      </div>
    </div>
  )
}

export default LeaguesConfigDropdowns
